import { render, staticRenderFns } from "./MealPrintCard.vue?vue&type=template&id=c3f9f5be&"
import script from "./MealPrintCard.vue?vue&type=script&lang=js&"
export * from "./MealPrintCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports